import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { VueAutosuggest } from 'vue-autosuggest';
import Http from '@/core/http/http.service';
import SearchSuggestQuickOrderResultsViewModel = Vertica.LouisPoulsen.Application.Search.ViewModels.SearchSuggestQuickOrderResultsViewModel;
import SearchSuggestViewObject = Vertica.LouisPoulsen.Application.Search.ViewModels.SearchSuggestViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickOrderSearchField',
  props: {
    placeholder: null,
    value: null
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: string): void, (e: 'submit', value: SearchSuggestViewObject): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {placeholder?: string, value?: string}




const selectedItem = ref<SearchSuggestViewObject>(undefined);
const term = ref<string>('');
const suggestions = ref<SearchSuggestViewObject[]>([]);

const suggestSequence = ref<number>(0);
const id = ref<number>(0);

const quickOrderSearchFieldSuggest = ref(null);

onMounted(() => { term.value = props.value; });

function renderSuggestion(suggestion) {
    return suggestion.item.name;
}

async function fetchSuggestions(term) {
    if (term) {
        const requestSeq = ++suggestSequence.value;
        const response = await Http.get<SearchSuggestQuickOrderResultsViewModel>('/search/searchsuggestquickorder', { term, includeContent: false });

        if (requestSeq === suggestSequence.value) {
            suggestions.value = response.suggestions;
        }
    } else {
        suggestions.value.length = 0;
    }

    emit('input', term);
}

function onSuggestionSelected(selected) {
    if (selected) {
        selectedItem.value = selected.item;
        term.value = selected.item.name;
        search();
    }
}

function enterSearch() {
    selectedItem.value = { name: term.value, productId: '' };
    search();
}

function search() {
    emit('input', term.value);
    suggestions.value.length = 0;
    emit('submit', selectedItem.value);

    blur();
}

const inputProps = computed<object>(() => {
    return {
        id: 'quickOrder_search_field_id' + id.value,
        name: 'quickOrder_search_field' + id.value,
        ref: 'quickOrderSearchField',
        type: 'text',
        autocomplete: 'off',
        autocapitalize: 'none'
    };
});

// Method for 'disabling' form tab arrows on iOS keyboard
function refocus(): void {
    const suggest = quickOrderSearchFieldSuggest.value as Vue;
    (suggest.$refs.quickOrderSearchField as HTMLElement).focus();
}

function blur(): void {
    const suggest = quickOrderSearchFieldSuggest.value as Vue;
    (suggest.$refs.quickOrderSearchField as HTMLElement).blur();
}


return { __sfc: true,props, emit, selectedItem, term, suggestions, suggestSequence, id, quickOrderSearchFieldSuggest, renderSuggestion, fetchSuggestions, onSuggestionSelected, enterSearch, search, inputProps, refocus, blur, VueAutosuggest }
}

})